import * as React from 'react';
import style from './JSFunctionDisplay.scss';
import { Rectangle } from '../../../../PageElements/Rectangle/Rectangle';
import { renderJSFunctionDisplay } from '../utils';
import syntaxDisplayTheme from './syntaxDisplayTheme';
import { HighlightDisplay } from '../../../../PageElements/HighlightDisplay';
import { StoreContext } from '../../../../../appContext/StoreProvider';
import { APPEARANCES, Heading } from '../../../../PageElements/Heading';

export const JSFunctionDisplay = ({ operation }) => {
  const { store } = React.useContext(StoreContext);

  return (
    <React.Fragment>
      <Heading dataHook="js-function-display-label" appearance={APPEARANCES.H3}>
        Syntax
      </Heading>
      <Rectangle className={style.syntaxDisplayContainer}>
        <span className="notranslate">
          <HighlightDisplay
            value={renderJSFunctionDisplay(operation, store)}
            language="javascript"
            theme={syntaxDisplayTheme}
            dataHook="high-light-display"
          />
        </span>
      </Rectangle>
    </React.Fragment>
  );
};
